<main class="flex min-h-screen items-center justify-center px-4 py-8">
  <div class="flex w-full max-w-md flex-col gap-6">
    <app-logo [widthInPx]="120" />

    <section hlmCard aria-labelledby="affiliate-title">
      <div hlmCardHeader>
        @if (pendingEmail(); as email) {
          <h1 hlmCardTitle id="affiliate-title">Bestätige deine E-Mail-Adresse</h1>
          <p hlmCardDescription>
            Wir haben dir einen Link an <strong>{{ email }}</strong> geschickt. Danach kannst du
            dich im Partnerbereich anmelden und bekommst deinen Empfehlungslink.
          </p>
        } @else {
          <h1 hlmCardTitle id="affiliate-title">Schenkwerk-Partner werden</h1>
          <p hlmCardDescription>
            Empfiehl Schenkwerk weiter oder betreue die Konten deiner Kunden. Wer sich über deinen
            persönlichen Link registriert, wird dir zugeordnet.
          </p>
        }
      </div>

      <div hlmCardContent class="space-y-6">
        @if (pendingEmail()) {
          <div hlmAlert role="status">
            <ng-icon name="lucideMail" />
            <p hlmAlertTitle>E-Mail ist unterwegs</p>
            <p hlmAlertDescription>
              Der Link ist 24 Stunden gültig. Prüfe auch deinen Spam-Ordner.
            </p>
          </div>
          <p class="text-center text-sm">
            @if (resent()) {
              Wir haben den Link noch einmal geschickt.
            } @else {
              Nichts angekommen?
              <button
                type="button"
                class="underline underline-offset-4"
                [disabled]="resending()"
                (click)="resend()">
                Link erneut senden
              </button>
            }
          </p>
        } @else {
          <app-affiliate-signup-form
            (registered)="pendingEmail.set($event)"
            (signedIn)="onSignedIn()" />
          <p class="text-center text-sm">
            Schon Partner?
            <a routerLink="/partner/login" class="underline underline-offset-4">Anmelden</a>
          </p>
        }
      </div>
    </section>
  </div>
</main>
